import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import offlineStorage from '../utils/offlineStorage';

const eligibilityCriteria = [
  "OUT OF GUAGE",
  "OVER WEIGHT BAG",
  "UN-MINORS",
  "NON ALIGNED AIRLINE",
  "PREMIUM PASSENGER",
  "PRM"
];


function Questions() {
  const navigate = useNavigate();
  const [checkedItems, setCheckedItems] = useState(
    eligibilityCriteria.reduce((acc, item) => {
      acc[item] = false; // default unchecked as per user feedback
      return acc;
    }, {})
  );

  const [airline, setAirline] = useState('');
  const [airlineCode, setAirlineCode] = useState('');
  const [airlines, setAirlines] = useState([]);

  useEffect(() => {
    // Clear checkboxes on component mount
    setCheckedItems(
      eligibilityCriteria.reduce((acc, item) => {
        acc[item] = false;
        return acc;
      }, {})
    );
  }, []);

  useEffect(() => {
    // Load airlines from localStorage and filter by selected terminal
    const storedAirlines = JSON.parse(localStorage.getItem('airlines')) || [];
    const selectedTerminal = localStorage.getItem('terminal');

    if (selectedTerminal) {
      // Filter airlines related to selected terminal
      const filteredAirlines = storedAirlines.filter(item => item.sys_terminal === selectedTerminal);
      setAirlines(filteredAirlines);
    } else {
      setAirlines(storedAirlines);
    }

    // Clear any previously selected airline to force user selection
    setAirline('');
    setAirlineCode('');
  }, []);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleAirlineChange = (event) => {
    const selectedAirlineName = event.target.value;
    setAirline(selectedAirlineName);
    const selectedAirline = airlines.find(item => item.sys_airlinename === selectedAirlineName);
    if (selectedAirline) {
      setAirlineCode(selectedAirline.sys_airlinecode);
      localStorage.setItem('airline', selectedAirlineName);
      localStorage.setItem('airlineCode', selectedAirline.sys_airlinecode);
    }
  };

  const [error, setError] = React.useState('');

  const handleEligibleClick = async () => {
    // Validate that airline is selected
    if (!airline || !airlineCode) {
      setError('Please select an airline before proceeding.');
      return;
    }

    const userRole = localStorage.getItem('userRole');
    const userId = localStorage.getItem('userId');
    const adminCode = localStorage.getItem('companyCode'); // Using userId as admin code
    const terminal = localStorage.getItem('terminal');

    // Call the API to record eligibility status
    const eligibilityData = {
      userId: userId,
      adminCode: adminCode,
      airlineCode: airlineCode,
      terminal: terminal,
      status: 'Eligible',
      reasons: null
    };
    
    try {
      const response = await fetch('https://starskan.com/api/make-eligible', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(eligibilityData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to record eligibility status');
      }
      
      // For COMPLIANCE Check role, go to HBR COMPLIANCE CHECK
      if (userRole === 'COMPLIANCE Check') {
        navigate('/welcome');//navigate('/consent');
      } else {
        // For other roles, go to welcome page
        navigate('/welcome');
      }
    } catch (error) {
      console.error('Error storing eligibility data:', error);
      // Still navigate even if storage fails
      if (userRole === 'COMPLIANCE Check') {
        navigate('/welcome');//navigate('/consent');
      } else {
        navigate('/welcome');
      }
    }
  };

  // Rename or remove duplicate handleNotEligibleClick to fix redeclaration error
  // const handleNotEligible = () => {
  //   if (Object.values(checkedItems).some(v => v)) {
  //     setError('');
  //     navigate('/consent');
  //   } else {
  //     setError('Please check at least one item to proceed.');
  //   }
  // };

  // const handleNotEligibleClick = () => {
  //   setCheckedItems(
  //     eligibilityCriteria.reduce((acc, item) => {
  //       acc[item] = false;
  //       return acc;
  //     }, {})
  //   );
  // };


  const handleNotEligibleClick = async () => {
    // Validate that airline is selected
    if (!airline || !airlineCode) {
      setError('Please select an airline before proceeding.');
      return;
    }

    if (Object.values(checkedItems).some(v => v)) {
      setError('');
      const userRole = localStorage.getItem('userRole');
      const userId = localStorage.getItem('userId');
      const adminCode = localStorage.getItem('companyCode'); // Using userId as admin code
      const terminal = localStorage.getItem('terminal');

      // Prepare reasons based on checked items
      const reasons = Object.keys(checkedItems)
        .filter(item => checkedItems[item])
        .join(', '); // Create a comma-separated string

      // Call the API to record eligibility status
      const eligibilityData = {
        userId: userId,
        adminCode: adminCode,
        airlineCode: airlineCode,
        terminal: terminal,
        status: 'Non-Eligible',
        reasons: reasons
      };
      
      try {
        const response = await fetch('https://starskan.com/api/make-eligible', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(eligibilityData)
        });
        
        if (!response.ok) {
          throw new Error('Failed to record eligibility status');
        }
        
        // For COMPLIANCE Check role, go to Welcome page
        if (userRole === 'COMPLIANCE Check') {
          navigate('/welcome');
        } else {
          // For other roles, go to welcome page
          navigate('/welcome');
        }
      } catch (error) {
        console.error('Error storing eligibility data:', error);
        // Still navigate even if storage fails
        if (userRole === 'COMPLIANCE Check') {
          navigate('/welcome');
        } else {
          navigate('/welcome');
        }
      }
    } else {
      setError('Please check at least one item to proceed.');
    }
  };

  // Derived state for button disabled status
  const anyChecked = Object.values(checkedItems).some(v => v);
  const isAirlineSelected = airline && airlineCode;
  const eligibilityButtonDisabled = anyChecked && isAirlineSelected;
  const notEligibleButtonDisabled = !anyChecked || !isAirlineSelected;

  

  return (
    <div style={{
      maxWidth: 400,
      margin: 'auto',
      padding: 20,
      backgroundColor: '#f0f0f5',
      borderRadius: 10,
      fontFamily: "'Arial Black', Arial, sans-serif",
      color: '#000',
      textAlign: 'center',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)'
    }}>
      {/* Placeholder for ARL Aviation Services logo */}
      <img
        src="/arl-logo.png"
        alt="ARL Aviation Services Logo"
        style={{ width: '100%', maxWidth: 250, marginBottom: 40, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
      />
      <h2 style={{ fontWeight: 'bold', marginBottom: 40, fontFamily: "'Arial Black', Arial, sans-serif", fontSize: 28, color: '#000' }}>Eligibility Check</h2>

      <div style={{ marginBottom: 20 }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 8 }}>Select Airline:</label>
        <select
          value={airline}
          onChange={handleAirlineChange}
          style={{
            width: '100%',
            padding: 8,
            borderRadius: 6,
            border: airline ? '1px solid #ccc' : '2px solid #d32f2f',
            backgroundColor: '#fff',
            color: airline ? '#000' : '#666',
            fontWeight: 'bold',
            fontSize: 16,
            fontFamily: "'Arial Black', Arial, sans-serif",
            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)'
          }}
        >
          <option value="" disabled>Select Airline</option>
          {airlines.map((item) => (
            <option key={item.sys_airlinecode} value={item.sys_airlinename}>
              {item.sys_airlinename}
            </option>
          ))}
        </select>
        {!airline && (
          <div style={{ color: '#d32f2f', fontSize: 14, marginTop: 5 }}>
            Please select an airline to proceed.
          </div>
        )}
      </div>

      <button
        onClick={handleEligibleClick}
        disabled={eligibilityButtonDisabled}
        style={{
          backgroundColor: '#2e7d32',
          color: 'white',
          fontWeight: 'bold',
          fontSize: 36,
          padding: '20px 0',
          width: '100%',
          border: 'none',
          borderRadius: 6,
          cursor: eligibilityButtonDisabled ? 'not-allowed' : 'pointer',
          marginBottom: 20,
          boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
          opacity: eligibilityButtonDisabled ? 0.6 : 1
        }}
      >
        ELIGIBLE
      </button>
      {error && (
        <div style={{ color: '#d32f2f', fontWeight: 'bold', marginBottom: 20 }}>
          {error}
        </div>
      )}

      <div style={{ textAlign: 'left', fontWeight: 'bold', fontSize: 16, marginBottom: 20 }}>
        {eligibilityCriteria.map(item => (
          <div key={item} style={{ marginBottom: 10, display: 'flex', alignItems: 'center' }}>
            <label style={{ flexGrow: 1 }}>{item}</label>
            <label style={{ position: 'relative', display: 'inline-block', width: 20, height: 20 }}>
              <input
                type="checkbox"
                name={item}
                checked={checkedItems[item]}
                onChange={handleCheckboxChange}
                style={{ opacity: 0, width: 20, height: 20, margin: 0, position: 'absolute', left: 0, top: 0, cursor: 'pointer' }}
              />
              <span style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: 20,
                width: 20,
                backgroundColor: '#fff',
                border: '2px solid #2e7d32',
                borderRadius: 4,
                boxSizing: 'border-box'
              }}></span>
              {checkedItems[item] && (
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#2e7d32"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    position: 'absolute',
                    top: 2,
                    left: 4,
                    width: 12,
                    height: 16,
                    pointerEvents: 'none'
                  }}
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
            </label>
          </div>
        ))}
      </div>

      <button
        onClick={handleNotEligibleClick}
        disabled={notEligibleButtonDisabled}
        style={{
          backgroundColor: '#d32f2f',
          color: 'white',
          fontWeight: 'bold',
          fontSize: 24,
          padding: '15px 0',
          width: '100%',
          border: 'none',
          borderRadius: 6,
          cursor: notEligibleButtonDisabled ? 'not-allowed' : 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
          opacity: notEligibleButtonDisabled ? 0.6 : 1
        }}
      >
        NOT ELIGIBLE
      </button>
    </div>
);
}

export default Questions;
